import { useMutation } from 'react-query';
import { lovageApi } from 'src/axios';

interface LegalAgreementsAcceptance {
  privacy_policy: boolean;
  terms_of_service: boolean;
}

export const acceptLegalAgreements = (data: {}) => {
  const request = {
    privacy_policy: true,
    terms_of_service: true,
  } as LegalAgreementsAcceptance;

  return lovageApi
    .post<LegalAgreementsAcceptance>(`/onboarding/agreements`, request)
    .then((res) => res.data);
};

export default function useAcceptLegalAgreements() {
  return useMutation(acceptLegalAgreements);
}
